module.exports = __webpack_public_path__ + "static/media/seta-branca.ad0e2d25.svg";